import React from 'react';


function encode(data) {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
}

export default class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = e => {
        e.preventDefault();
        const form = e.target;
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: encode({
                "form-name": form.getAttribute("name"),
                ...this.state
            })
        })
            .then(() => alert("Success!"))
            .catch(error => alert(error));
    };

    render() {
        return (

            <form
                name="contact"
                method="post"
                action="/"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                onSubmit={this.handleSubmit}
            >

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
                            <input type="hidden" name="form-name" value="contact" />
                            <p hidden>
                                <label>
                                    Don’t fill this out:{" "}
                                    <input name="bot-field" onChange={this.handleChange} />
                                </label>
                            </p>
                            <input className="form-control" id="name" name="name" type="text" placeholder="Your Name *" required="required"
                                data-validation-required-message="Please enter your name." onChange={this.handleChange} />
                            <p className="help-block text-danger"></p>
                        </div>
                        <div className="form-group">
                            <input className="form-control" id="email" name="email" type="email" placeholder="Your Email *"
                                required="required" data-validation-required-message="Please enter your email address." onChange={this.handleChange} />
                            <p className="help-block text-danger"></p>
                        </div>
                        <div className="form-group">
                            <input className="form-control" id="phone" name="phone" type="tel" placeholder="Your Phone *" required="required"
                                data-validation-required-message="Please enter your phone number." onChange={this.handleChange} />
                            <p className="help-block text-danger"></p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <textarea className="form-control" id="message" name="message" placeholder="Your Message *"
                                required="required" data-validation-required-message="Please enter a message." onChange={this.handleChange}></textarea>
                            <p className="help-block text-danger"></p>
                        </div>
                    </div>
                    <div className="clearfix"></div>
                    <div className="col-lg-12 text-center">
                        <div id="success"></div>
                        <button id="sendMessageButton" className="btn btn-primary btn-xl text-uppercase" type="submit">Send Message</button>
                    </div>
                </div>

            </form>

        );
    }
}